<template>
  <div>
    <v-toolbar flat color="white" style="height: 22px !important;">
      <!-- <v-toolbar-title>Grupos de despesas do sistema</v-toolbar-title> -->
      <!-- <v-spacer></v-spacer> -->

      <ExpenseGroupFormDlg
        :expGrpDialog="expGrpDialog"
        :openForm="() => openForm()"
        :closeForm="() => closeForm()"
        :saveExpenseGroup="(data) => saveExpenseGroup(data)"
        :editDataExpGrp="formData"
      />
    </v-toolbar>
    <SearchExpensesGroups :searchExpGroups="(form) => getEspensesGroups(form)" />
    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.code }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-center layout">
          <!-- <v-icon small class="mr-2" @click="editItem(props.item, 'viewForm')">remove_red_eye</v-icon> -->
          <v-btn class="mx-0" flat icon @click="openForm(props.item)" v-if="permissions.edit">
            <v-icon small>edit</v-icon>
          </v-btn>

          <v-btn
            v-if="!props.item.active && permissions.edit"
            flat
            icon
            @click="confirmToogleStatusItem(props.item)"
          >
            <v-icon small>check</v-icon>
          </v-btn>
          <v-btn
            v-if="props.item.active && permissions.edit"
            flat
            icon
            @click="confirmToogleStatusItem(props.item)"
          >
            <v-icon small>block</v-icon>
          </v-btn>

          <v-btn class="mx-0" flat icon @click="confirmDelExpGroup(props.item)" v-if="permissions.remove">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data>
        <p
          class="pt-5"
          style="min-height: 200px;"
        >Preencha os campos acima para listar os grupos de despesas do sitema</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ExpenseGroupFormDlg from './ExpenseGroupFormDlg.vue'
import SearchExpensesGroups from './SearchExpensesGroups.vue'

export default {
  name: 'Expenses',

  components: {
    ExpenseGroupFormDlg,
    SearchExpensesGroups
  },

  data () {
    return {
      lastRequestData: {},
      formData: {},
      expGrpDialog: false,
      headers: [
        { align: 'left', text: 'Código', sortable: false, value: 'code' },
        {
          text: 'Descrição do grupo de despesa',
          value: 'name',
          sortable: false,
          align: 'left'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  mounted () {
    this.getEspensesGroups()
  },
  computed: {
    permissions () {
      return this.$store.state.permissions.permissions.standardSystem
    }
  },
  methods: {
    confirmToogleStatusItem (data) {
      let action = data.active ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} o grupo de despesas "${data.name}"?`,
        title: `${
          data.active
            ? 'Desativar grupo de despesas'
            : 'Ativar grupo de despesas'
        }`,
        callback: _ => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    toogleStatusItem (data) {
      let obj = {
        url: '/api/defaultExpenseGroup/disable_group/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Status modificado com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getEspensesGroups()
      })
    },

    confirmDelExpGroup (data) {
      let obj = {
        message: `Você deseja excluir o grupo de despesas "${data.name}"?`,
        title: 'Excluir grupo de despesa',
        callback: _ => {
          this.delExpGroup(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delExpGroup (data) {
      let obj = {
        url: '/api/defaultExpenseGroup/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let opts = {
          message: `Grupo de despesas removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getEspensesGroups()
      })
    },

    saveExpenseGroup (data) {
      //      console.log(data);
      let obj = {
        url: '/api/defaultExpenseGroup' + (data.id ? `/${data.id}` : ''),
        query: data,
        method: data.id ? 'patch' : 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        let opts = {
          message: `Grupo de despesas salvo com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)

        this.formData = { ...response.data }
        this.getEspensesGroups()
      })
    },

    openForm (data) {
      if (data) {
        this.formData = { ...data }
      } else {
        this.formData = {}
      }
      this.expGrpDialog = true
    },

    closeForm () {
      this.expGrpDialog = false
    },

    getEspensesGroups (filters) {
      if (!filters) {
        filters = this.lastRequestData
      }
      let dataSearch = {}
      if (filters) {
        dataSearch.params = {
          ...filters
        }
      }
      let obj = {
        url: '/api/defaultExpenseGroup',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.tableData = response.data
        this.lastRequestData = filters
      })
    }
  }
}
</script>

<style>

</style>
